import { WrappedFormUtils } from "antd/es/form/Form";
import { FormItemProps } from "antd/es/form";
import moment from "moment";

/**
 * Универсальный хелпер для вычисления formItemOpts
 * @param form - объект формы AntD v3
 * @param dataInstance - данные из dataInstance
 * @param propertyName - имя поля (совпадает с propertyName в NewReadonlyField)
 */
export function getFormItemOpts<T>(
  form: WrappedFormUtils<T>,
  dataInstance: Partial<T> | undefined,
  propertyName: keyof T,
): Pick<FormItemProps, "hasFeedback" | "validateStatus"> {
  const fieldError = form.getFieldError(propertyName as string);
  const formValue = form.getFieldValue(propertyName as string);
  const dataValue = dataInstance?.[propertyName];

  let hasChanged = false;

  // 1. Проверка moment-даты
  if (moment.isMoment(dataValue) || moment.isMoment(formValue)) {
    const m1 = moment(dataValue);
    const m2 = moment(formValue);
    hasChanged = !m1.isSame(m2, "day");
  }

  // 2. Проверка объекта с id
  else if (
    dataValue &&
    typeof dataValue === "object" &&
    "id" in (dataValue as any)
  ) {
    hasChanged =
      (dataValue as any).id !==
        (formValue && typeof formValue === "object"
          ? (formValue as any).id || formValue
          : formValue) && formValue !== null;
  }

  // 3. Проверка массива объектов с id
  else if (Array.isArray(dataValue) && Array.isArray(formValue)) {
    const dataIds = dataValue.map((item: any) => item?.id).filter(Boolean);
    const formIds = formValue.map((item: any) => item?.id).filter(Boolean);

    if (dataIds.length !== formIds.length) {
      hasChanged = true;
    } else {
      hasChanged = dataIds.some((id, idx) => id !== formIds[idx]);
    }
  }

  // 4. Простые типы
  else {
    hasChanged = dataValue !== formValue && formValue !== null;
  }

  return {
    hasFeedback: hasChanged,
    validateStatus: fieldError && fieldError.length > 0 ? "error" : undefined,
  };
}
